import Vue from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import Login from '../views/login/index.vue';
import Verify from '../views/login/verify.vue';
import Dashboard from '../views/dashboard/index.vue';
// import layout from '../layout/layout.vue';

// Vue.use(Router);

// export default new Router({
//   mode: 'hash',
//   base: process.env.BASE_URL,
  const routes = [{
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title: 'Merchant Login',
    },
  },
  {
    path: '/verify',
    name: 'verify',
    component: Verify,
    meta: {
      title: 'Verify Auth Code',
    },
  },
  {
    path: '/dashboard',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: Dashboard,
      meta: {
        breadcrumb: [{
          name: 'Dashboard',
        }],
        title: 'Dashboard',
      },
    }],
  },

  {
    path: '/collect/transactions',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                    import ('@/views/collection/transactions.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Transactions',
        }],
        title: 'Transactions',
      },
    }],
  },
  {
    path: '/2factor',
    component: () =>
        import ('@/layout/layout.vue'),
    children: [{
    path: '',
    name: '',
    component: () =>
                    import ('@/views/2factor/index.vue'),
    meta: {
    breadcrumb: [{
      name: '2FA Authentication',
    }],
    title: '2FA Authentication',
    },
    },

    ],
  },
  {
    path: '/settlement-bank-accounts',
    component: () =>
        import ('@/layout/layout.vue'),
    children: [{
    path: '',
    name: '',
    component: () =>
                    import ('@/views/bankAccounts/settlementBankAccounts.vue'),
    meta: {
    breadcrumb: [{
      name: 'Settlement Bank Accounts',
    }],
    title: 'Settlement Bank Accounts',
    },
    },

    ],
  },
  {
    path: '/collect/settlements',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                        import ('@/views/common/settlements.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Settlements',
        }],
        title: 'Settlements',
      },
    },
    {
      path: '/collect/settlements/:id',
      name: 'virtual-account-settlement-detail',
      component: () =>
                        import ('@/views/collection/settlementDetail.vue'),
                    meta: {
                        productCode: 'VIRTUAL_ACCOUNT',
                        breadcrumb: [{
                                name: 'Settlements',
                                link: '/collect/settlements',
                            },
                            {
                                name: 'Detail',
                            },
                        ],
                        title: 'Settlement Detail',
                    },
                },
                {
                    path: '/collect/search',
                    name: 'virtual-account-search',
                    component: () =>
                        import ('@/views/collection/search.vue'),
                    meta: {
                        productCode: 'VIRTUAL_ACCOUNT',
                        breadcrumb: [{
                            name: 'Search',
                        }, ],
                        title: 'Search',
                    },
                }
            ],
        },
        {
            path: '/changePassword',
            component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                        import ('@/views/changePassword/index.vue'),
      meta: {
        breadcrumb: [{
          name: 'Change Login Password',
        }],
        title: 'Change Login Password',
      },
    },

    ],
  },
  {
    path: '/collect/customers',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                        import ('@/views/collection/customers.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Customers',
        }],
        title: 'Customers',
      },
    },

    ],
  },

  {
    path: '/billing',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'invoice-list',
      name: 'Invoice',
      component: () =>
                        import ('@/views/billing/invoicelist.vue'),
      meta: {
        breadcrumb: [{
          name: 'Invoice',
        }],
        title: 'Invoice',
      },
    },

    ],
  },

  // For UPI Daily, Month Transaction

  {
    path: '/upi',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'transactions-daily',
      name: 'upi-daily-statement',
      component: () =>
                        import ('@/views/upi/trandaily.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Daily Statement',
        }],
        title: 'Daily Statement',
      },
    },
    {
      path: 'transactions-monthly',
      name: 'upi-monthly-statement',
      component: () =>
                        import ('@/views/upi/tranmonthly.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Monthly Statement',
        }],
        title: 'Monthly Statement',
      },
    },
    {
      path: 'validation-statement',
      name: 'upi-validation-statement',
      component: () =>
                        import ('@/views/upi/verifystmt.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'UPI Validation Statement',
        }],
        title: 'UPI Validation Statement',
      },
    },

    {
      path: 'payment-link-bulk-upload',
      name: 'Payment Link Bulk Upload',
      component: () =>
                        import ('@/views/upi/paymentLinkBulkUpload.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Payment Link Bulk Upload',
        }],
        title: 'Payment Link Bulk Upload',
      },
    },
    {
      path: 'bulk-link-payment',
      name: 'Bulk Link Payments',
      component: () =>
                        import ('@/views/upi/bulkLinkPaymentList.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Bulk Link Payments',
        }],
        title: 'Bulk Link Payments',
      },
    },
    {
      path: 'bulk-link-detail',
      name: 'Bulk Link Payments Detail',
      component: () =>
                        import ('@/views/upi/bulkLinkPaymentDetails.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Bulk Link Payments',
          link: '/upi/bulk-link-payment',
        },
        {
          name: 'Bulk Link Payments Detail', 
        },
        ],
        title:"Bulk Link Payments Detail"
      },
    },
    {
      path: 'upload-bulk-link-payment',
      name: 'Create Bulk Link Payments',
      component: () =>
                        import ('@/views/upi/createBulkLinkPayment.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Bulk Link Payments',
          link: '/upi/bulk-link-payment',
        },
        {
          name: 'Create Bulk Link Payments', 
        },
        ],
        title:"Create Bulk Link Payments"
      }
    },
    {
      path: 'bulk-link-details/uploaded-details/:pk',
      name: 'Bulk Link Payments Uploaded Details',
      component: () =>
                        import ('@/views/upi/bulkLinkPaymentUploadDetails.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Bulk Link Payments Detail',
          link: '/upi/bulk-link-detail/?sk=:sk',
        },
        {
          name: 'Bulk Link Payments Uploaded Details', 
        },
        ],
        title:"Bulk Link Payments Uploaded Details"
      },
    },
    // Payment - Pages
    {
      path: 'payment-pages-transactions-daily',
      name: 'upi-payment-pages-transactions-daily',
      component: () =>
                        import ('@/views/upi/paymentPagesTranDaily.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Payment Pages Transactions Daily',
        }],
        title: 'Payment Pages Transactions Daily',
      },
    },
    {
      path: 'payment-pages-transactions-monthly',
      name: 'upi-payment-pages-transactions-monthly',
      component: () =>
                        import ('@/views/upi/paymentPagesTranMonthly.vue'),
      meta: {
       productCode: 'UPI',
        breadcrumb: [{
          name: 'Payment Pages Transactions Monthly',
        }],
        title: 'Payment Pages Transactions Monthly',

      },
    }
    ],
  },

  // End for UPI Daily, Month Transaction

  {
    path: '/invoice-detail/:id',
    component: () =>
                import ('@/views/billing/invoicedetail.vue'),
    meta: {
      roleIds: '30',
      title: 'Invoice Detail',
    },
  }, {
    path: '/collect',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'transactions-daily',
      name: 'virtual-account-daily-statement',
      component: () =>
                        import ('@/views/collection/trandaily.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Daily Statement',
        }],
        title: 'Daily Statement',
      },
    },
    {
      path: 'transactions-monthly',
      name: 'virtual-account-monthly-statement',
      component: () =>
                        import ('@/views/collection/tranmonthly.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Monthly Statement',
        }],
        title: 'Monthly Statement',
      },
    },
    {
      path: 'consolidate-monthly',
      name: 'Consolidated Statement',
      component: () =>
                        import ('@/views/collection/consolidatemonthly.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Consolidated Statement',
        }],
        title: 'Consolidated Statement',
      },
    },
    ],
  },
  {
    path: '/ondemand-settlement',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'statements',
      name: 'Statements',
      component: () =>
                        import ('@/views/onDemandSettlement/statements.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Statements',
        }],
        title: 'Statements',
      },
    },
    {
      path: 'bulkondemandsettlements',
      name: 'Bulk Refunds',
      component: () =>
                        import ('@/views/onDemandSettlement/bulkondemandsettlements.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Bulk Refunds',
        }],
        title: 'Bulk Refunds',
      },
    },
    {
      path: '/ondemand-settlement/bulkondemandsettlements/create',
      name: 'Create Bulk Refunds',
      component: () =>
                        import ('@/views/onDemandSettlement/createbulkondemandsettlements.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Bulk Refunds',
          link: '/ondemand-settlement/bulkondemandsettlements',
        },
        {
          name: 'Create Bulk Refunds', // crumb text
        },
        ],
      },
    },
    {
      path: '/ondemand-settlement/bulkondemandsettlements/detail/:batchId',
      name: 'Bulk Refunds Detail',
      component: () =>
                        import ('@/views/onDemandSettlement/bulkondemandsettlementDetails.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Bulk Refunds',
          link: '/ondemand-settlement/bulkondemandsettlements',
        },
        {
          name: 'Bulk Refunds Detail', // crumb text
        },
        ],
      },
    },
    {
      path: '/ondemand-settlement/summary',
      name: 'Summary',
      component: () =>
                        import ('@/views/onDemandSettlement/summary.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Summary',
        }],
        title: 'Summary',
      },
    },
    {
      path: '/ondemand-settlement/reportsbydaterange',
      name: 'Date Range Statement',
      component: () =>
                        import ('@/views/onDemandSettlement/reports.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Date Range Statement',
        }],
        title: 'Date Range Statement',
        reload: true,
      },
    },
    {
      path: '/ondemand-settlement/dailyreport',
      name: 'Refunds Daily Statement',
      component: () =>
                        import ('@/views/onDemandSettlement/reports.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Refunds Daily Statement',
        }],
        title: 'Refunds Daily Statement',
        reload: true,
      },
    },
    {
      path: '/ondemand-settlement/monthlyreport',
      name: 'Refunds Monthly Statement',
      component: () =>
                        import ('@/views/onDemandSettlement/monthly.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Refunds Monthly Statement',
        }],
        title: 'Refunds Monthly Statement',
        reload: true,
      },
    },
    {
      path: '/ondemand-settlement/recreditsummary',
      name: 'Recredit Summary',
      component: () =>
                        import ('@/views/onDemandSettlement/recreditsummary.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Recredit Summary',
        }],
        title: 'Recredit Summary',
        reload: true,
      },
    },


    {
      path: '/ondemand-settlement/search',
      name: 'Search',
      component: () =>
                        import ('@/views/onDemandSettlement/search.vue'),
      meta: {
        productCode: 'ONDEMAND_SETTLEMENT',
        breadcrumb: [{
          name: 'Search',
        }],
        title: 'Search',
      },
    },
    ],
   },

  // for upi
  {
    path: '/upi',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'transactions',
      name: 'upi-transactions',
      component: () =>
                        import ('@/views/upi/transactions.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'UPI Transactions',
        }],
        title: 'UPI Transactions',
      },
    },
    {
      path: 'search',
      name: 'upi-search',
      component: () =>
                        import ('@/views/upi/search.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'UPI Search',
        }],
        title: 'UPI Search',
      },
    },
    {
      path: 'payment-pages',
      name: 'upi-payment-pages',
      component: () =>
                        import ('@/views/upi/paymentPages.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Payment Pages',
        }],
        title: 'Payment Pages',
      },
    },
    {
      path: 'payment-pages/details/:id',
      name: 'Payment Pages Details',
      component: () =>
                        import ('@/views/upi/paymentPagesDetails.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Payment Pages',
          link: '/upi/payment-pages',
        },
        {
          name: 'Payment Pages Details', // crumb text
        },
        ],
        title:"Payment Pages Details"
      },
    },
    {
      path: 'paymentlink',
      name: 'upi-payment-link',
      component: () =>
                        import ('@/views/upi/paymentLink.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Link Payments',
        }],
        title: 'Link Payments',
      },
    },
    {
      path: 'paymentlink/create',
      name: 'Create Link Payment',
      component: () =>
      import ('@/views/upi/paymentLinkCreate.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Link Payments',
          link: '/upi/paymentlink',
        },
        {
          name: 'Create Link Payment', // crumb text
        },
        ],
        title:"Create Link Payment"
      },
    },
    {
      path: 'paymentlink/details/:id',
      name: 'Link Payment Details',
      component: () =>
                        import ('@/views/upi/paymentLinkDetails.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Link Payments',
          link: '/upi/paymentlink',
        },
        {
          name: 'Link Payment Details', // crumb text
        },
        ],
        title:"Link Payment Details"
      },
    },
    {
      path: 'dynamicqr',
      name: 'upi-dynamic-qr',
      component: () =>
                        import ('@/views/upi/dynamicQR.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'Dynamic QR',
        }],
        title: 'Dynamic QR',
      },
    },
    {
      path: 'refund/:id',
      name: 'UPI Refund',
      component: () =>
                        import ('@/views/upi/upiRefund.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [
        {
          name: 'Refund',
        }
        ],
        title:"Refund"
      },
    },
    {
      path: 'settlements',
      name: 'common-settlements',
      component: () =>
                        import ('@/views/common/settlements.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'UPI Settlements',
        }],
        title: 'UPI Settlements',
      },
    },
    {
      path: '/upi/settlements/:id',
      name: 'upi-settlement-detail',
      component: () =>
                        import ('@/views/upi/settlementDetail.vue'),
      meta: {
        productCode: 'UPI',
        breadcrumb: [{
          name: 'UPI Settlements',
          link: '/upi/settlements',
        },
        {
          name: 'UPI Settlement Detail', // crumb text
        },],
        title: 'UPI Settlement Detail',
      },
    },
    ],
  },
  {
    path: '/error',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                    import ('@/views/common/error.vue'),
      meta: {
        title: 'Error',
      },
    }],
  },
  // for access management
  {
    path: '/usermanagement',
    name:'user-management',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: '',
      name: '',
      component: () =>
                        import ('@/views/clientlogins/list.vue'),
      meta: {
        breadcrumb: [{
          name: 'Logins',
        }],
        title: 'Logins',
      },
    },
    {
      path: 'details/:id',
      component: () =>
                      import ('@/views/clientlogins/details.vue'),
      meta: {
        breadcrumb: [{
          name: 'Logins',
          link: '/usermanagement',
        },
        {
          name: 'Detail', // crumb text
        }],
        title: 'Logins Detail',
      },
    },
    {
      path: '/usermanagement/createlogin',
      name:'create-login',
      component: () =>
                      import ('@/views/clientlogins/createLogin.vue'),
      meta: {
        breadcrumb: [{
          name: 'Logins',
          link: '/usermanagement',
        },
        {
          name: 'Create Login', // crumb text
        },
        ],
        title: 'Create Login',
      },

    },
    {
      path: 'upload',
      component: () =>
                      import ('@/views/clientlogins/uploadLogins.vue'),
      meta: {
        breadcrumb: [{
          name: 'Logins',
          link: '/usermanagement',
        },
        {
          name: 'Upload Logins', // crumb text
        },
        ],
        title: 'Upload Logins',
      },
    },

    ],
  },
  {
    path: '/order',
    component: () =>
      import('@/layout/layout.vue'),
    children: [{
      path: 'orderlist',
      name: 'Order List',
      component: () =>
        import('@/views/collection/orderList.vue'),
      meta: {
        productCode: 'VIRTUAL_ACCOUNT',
        breadcrumb: [{
          name: 'Order List',
        }],
        title: 'Order List',
      },
    }
    ],
  },

  // for cash collect product

  {
    path: '/cashcollect',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'customer-list',
      name: 'customer-list',
      component: () =>
                        import ('@/views/cashCollect/customers.vue'),
      meta: {
        productCode: 'CASH_COLLECT',
        breadcrumb: [{
          name: 'Customers',
        }],
        title: 'Customers',
      },
    },
    {
      path: 'transactions',
      name: 'cash-collect-transactions',
      component: () =>
                        import ('@/views/cashCollect/transactions.vue'),
      meta: {
        productCode: 'CASH_COLLECT',
        breadcrumb: [{
          name: 'Transactions',
        }],
        title: 'Transactions',
      },
    },
    {
      path: 'transactions-daily',
      name: 'cash-collect-daily-statement',
      component: () =>
                        import ('@/views/cashCollect/trandaily.vue'),
      meta: {
        productCode: 'CASH_COLLECT',
        breadcrumb: [{
          name: 'Daily Statement',
        }],
        title: 'Daily Statement',
      },
    },
    {
      path: 'transactions-monthly',
      name: 'cash-collect-monthly-statement',
      component: () =>
                        import ('@/views/cashCollect/tranmonthly.vue'),
      meta: {
        productCode: 'CASH_COLLECT',
        breadcrumb: [{
          name: 'Monthly Statement',
        }],
        title: 'Monthly Statement',
      },
    },

    ],
  },
  // BBPS Biller
  {
    path: '/bbps',
    component: () =>
                import ('@/layout/layout.vue'),
    children: [{
      path: 'transactions',
      name: 'transactions',
      component: () =>
                        import ('@/views/bbpsBiller/transactions.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS Biller Transactions',
        }],
        title: 'BBPS Biller Transactions',
      },
    },
    {
      path: 'search',
      name: 'search',
      component: () =>
                        import ('@/views/bbpsBiller/search.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS Biller Search',
        }],
        title: 'BBPS Biller Search',
      },
    },
    {
      path: 'bills',
      name: '',
      component: () =>
                        import ('@/views/bbpsBiller/bills.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS Biller Bills',
        }],
        title: 'BBPS Biller Bills',
      },
    },
    {
      path: 'bills/create',
      name: 'BBPS Bills Create',
      component: () =>
                        import ('@/views/bbpsBiller/billsCreate.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS Biller Bills',
          link: '/bbps/bills',
        },
        {
          name: 'BBPS Bills Create', // crumb text
        },
        ],
      },
    },
    {
      path: 'settlements',
      name: 'settlements',
      component: () =>
                        import ('@/views/common/settlements.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS_BOU Settlements',
        }],
        title: 'BBPS_BOU Settlements',
      },
    },
    {
      path: '/bbps/settlements/:id',
      name: 'settlement detail',
      component: () =>
                        import ('@/views/bbpsBiller/settlementDetail.vue'),
      meta: {
        productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'BBPS_BOU Settlements',
          link: '/bbps/settlements',
        },
        {
          name: 'BBPS_BOU Settlement Detail', // crumb text
        },],
        title: 'BBPS_BOU Settlement Detail',
      },
    },
    {
      path: 'transactions-daily',
      name: 'Daily Statement',
      component: () =>
                        import ('@/views/bbpsBiller/trandaily.vue'),
      meta: {
       productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'Daily Statement',
        }],
        title: 'Daily Statement',
      },
    },
    {
      path: 'transactions-monthly',
      name: 'Monthly Statement',
      component: () =>
                        import ('@/views/bbpsBiller/tranmonthly.vue'),
      meta: {
       productCode: 'BBPS_BOU',
        breadcrumb: [{
          name: 'Monthly Statement',
        }],
        title: 'Monthly Statement',
      },
    }
  ]
  },

  // STATIC QR 
  {
      path: '/upi-static-qr',
      component: () =>
                  import ('@/layout/layout.vue'),
      children: [
        {
        path: 'transactions',
        name: 'upi-static-qr-transactions',
        component: () =>
                          import ('@/views/upiStaticQR/transactions.vue'),
        meta: {
          productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'UPI Static QR Transactions',
          }],
          title: 'UPI Static QR Transactions',
        },
      },
      {
        path: 'search',
        name: 'upi-static-qr-search',
        component: () =>
          import ('@/views/upiStaticQR/search.vue'),
        meta: {
          productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'UPI Static QR Search',
          }],
          title: 'UPI Static QR Search',
        },
      },
      {
        path: 'settlements',
        name: 'upi-static-qr-settlements',
        component: () =>
                          import ('@/views/common/settlements.vue'),
        meta: {
          productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'UPI Static QR Settlements',
          }],
          title: 'UPI Static QR Settlements',
        },
      },
      {
        path: 'settlements/:id',
        name: 'upi-static-qr-settlement-detail',
        component: () =>
                          import ('@/views/upiStaticQR/settlementDetail.vue'),
        meta: {
          productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'UPI Static QR Settlements',
            link: '/upi-static-qr/settlements',
          },
          {
            name: 'UPI Static QR Settlement Detail', // crumb text
          },],
          title: 'UPI Static QR Settlement Detail',
        },
      },
      {
        path: 'transactions-daily',
        name: 'upi-static-qr-daily-statement',
        component: () =>
                          import ('@/views/upiStaticQR/trandaily.vue'),
        meta: {
        productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'Daily Statement',
          }],
          title: 'Daily Statement',
        },
      },
      {
        path: 'transactions-monthly',
        name: 'upi-static-qr-monthly-statement',
        component: () =>
                          import ('@/views/upiStaticQR/tranmonthly.vue'),
        meta: {
        productCode: 'UPI_STATIC_QR',
          breadcrumb: [{
            name: 'Monthly Statement',
          }],
          title: 'Monthly Statement',
        },
      },
    ]
  },

  {
    path: '/settings',
    component: () =>
      import('@/layout/layout.vue'),
    children: [{
      path: 'product-configurations',
      name: 'Configurations',
      component: () =>
                        import ('@/views/clientlogins/webhook.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
        }],
        title: 'Configurations',
      },
    },
    {
      path: 'productinfo/:id',
      name: 'ProductInfo',
      component: () =>
          import ('@/views/clientlogins/productInfo.vue'),
          meta: {
            breadcrumb: [{
              name: 'Configurations',
              link: '/settings/product-configurations'
            }],
            title: 'Configurations',
          },
    },
    {
      path: 'manage-tokens',
      name: 'ManageTokens',
      component: () =>
          import ('@/views/clientlogins/manageKeys.vue'),
          meta: {
            breadcrumb: [{
              name: 'API Tokens',
            }],
            title: 'API Tokens',
          },
    },
    {
      path: 'upi-api-document',
      name: 'upi-api-document',
      component: () =>
                        import ('@/views/clientlogins/upiAPIUrlDoc.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
          link: '/settings/product-configurations',
        },
        {
          name: 'UPI',
        },{
          name: 'View',
        }],
        title: 'API URL and Postman Collection',
      },
    },
    {
      path: 'ecollect-api-document',
      name: 'ecollect-api-document',
      component: () =>
                        import ('@/views/clientlogins/ecollectAPIUrlDoc.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
          link: '/settings/product-configurations',
        },
        {
          name: 'Collect',
        },{
          name: 'View',
        }],
        title: 'API URL and Postman Collection',
      },
    },
    {
      path: 'upi-link-payment-api-document',
      name: 'upi-link-payment-api-document',
      component: () =>
                        import ('@/views/clientlogins/upiLinkPaymentAPIUrlDoc.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
          link: '/settings/product-configurations',
        },
        {
          name: 'UPI Link Payment',
        },{
          name: 'View',
        }],
        title: 'API URL and Postman Collection',
      },
    },
    {
      path: 'settlement-api-document',
      name: 'settlement-api-document',
      component: () =>
                        import ('@/views/clientlogins/settlementAPIUrlDoc.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
          link: '/settings/product-configurations',
        },
        {
          name: 'Settlement API',
        },{
          name: 'View',
        }],
        title: 'API URL and Postman Collection',
      },
    },
    {
      path: 'refund-api-document',
      name: 'refund-api-document',
      component: () =>
                        import ('@/views/clientlogins/refundAPIUrlDoc.vue'),
      meta: {
        breadcrumb: [{
          name: 'Configurations',
          link: '/settings/product-configurations',
        },
        {
          name: 'Refunds',
        },{
          name: 'View',
        }],
        title: 'API URL and Postman Collection',
      },
    },
    ],
  },
  {
    path: '/404', 
    name: '404',
    component: () => import ('@/views/common/error.vue'),
  },
  {
    path: '/:catchAll(.*)', 
    redirect:"/404"
  }
  ]

  const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: 'active', // active class for non-exact links.
    linkExactActiveClass: 'active', // active class for *exact* links.
  })

  export default router;

//   linkActiveClass: 'active', // active class for non-exact links.
//   linkExactActiveClass: 'active', // active class for *exact* links.
// });
